import en from './lang/en.json';
import ko from './lang/ko.json';
import zh from './lang/zh.json';
import ja from './lang/ja.json';
import ru from './lang/ru.json';
import ar from './lang/ar.json';
import mn from './lang/mn.json';
import vi from './lang/vi.json';

export default {en, zh, ja, ru, ar, mn, vi, ko};